import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import ChildrenEntities from 'client/components/core/ChildrenEntities'
import React from 'react'
import { CommonWebsiteFooter } from 'src/shared/entities/website-footer'
import { WebsiteFooterInterface } from 'src/shared/types/website-footer-interface'

export interface WebsiteFooterProps {
  entity: WebsiteFooterInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const WebsiteFooter = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: WebsiteFooterProps) => (
  <BaseEntityNew
    entity={entity}
    isMoveUpAllowed={isMoveUpAllowed}
    isMoveDownAllowed={isMoveDownAllowed}
  >
    <CommonWebsiteFooter htmlAttrId={entity.htmlAttrId}>
      <ChildrenEntities
        id={entity.id}
        childIds={entity.childIds}
        type={entity.type}
        isReadOnly={entity.isReadOnly}
      />
    </CommonWebsiteFooter>
  </BaseEntityNew>
)
